import { useMutation } from '@apollo/client/react';
import { CREATE_CHAT_MESSAGE } from '../queries/CreateChatMessage';
import { ChatMessage, SendMessageParams } from '../types/Chat';
import { loggerService } from '@brainpool/logger';
import { LoggerContextProps } from '../types/LogContext';
import { GET_CHAT_MESSAGES } from '../queries/GetChatMessages';
import { handleError } from './errorHandler';

export function useSendMessage() {
  const context: LoggerContextProps = {
    action: 'getCase',
    caseId: '',
  };

  const [sendMessageMutation, { data, loading, error }] = useMutation<{
    createChatMessage: ChatMessage;
  }>(CREATE_CHAT_MESSAGE);

  const sendMessage = async ({
    content,
    chatId,
    caseId,
    role = 'USER',
    use_google_search,
  }: SendMessageParams) => {
    if (!chatId || !content || !caseId) {
      loggerService.log({
        message: 'Chat ID, message content, and case ID are required',
        logLevel: 'error',
        context: {
          action: 'sendMessage',
          chatId,
          caseId,
        },
      });
      return;
    }
    try {
      const { data } = await sendMessageMutation({
        variables: {
          input: {
            content,
            case_id: caseId,
            chat_id: chatId,
            role,
            use_google_search: use_google_search || false,
          },
        },
        refetchQueries: [
          {
            query: GET_CHAT_MESSAGES,
            variables: {
              filter: {
                case_id: caseId,
                chat_id: chatId,
              },
            },
          },
        ],
      });
    } catch (error) {
      handleError(error, context, 'Failed to send message.');
    }
  };

  return { sendMessage, data, loading, error };
}
